import { JogId, Jog, Agency, AgencyId } from ".";
import { WspFakeAgencies } from "./wsp-fake-agencies";

const JogMap = new Map<string, Jog>();

const isUserJog = true;
const notIsUserJog = !isUserJog;
const isGroupOnly = true;
const isFilter = true;
const notIsFilter = !isFilter;

const makeJog = (agencies: Agency[], id: JogId, name: string, shortName: string, isFilter = true, isUserJog = true, isGroupOnly = false): Jog => {
  return {
    id,
    name,
    shortName,
    // The JOG's agencies are based on the same source as the agencies seen in state. When when the saga for getAgencies is called, it then calls MakeJogs() and passes the agencies to that, which passes those to this.
    agencies: getJogAgencies(id, agencies).concat(getJogAgencies(id, WspFakeAgencies)).sort((a, b) => a.shortName < b.shortName ? -1 : 1), // todo: get real agencies from store, fake agencies from fakes
    isFilter,
    isUserJog,
    isGroupOnly,
  }
}
const agencyJogsMap = new Map<AgencyId, Set<JogId>>();

const getJogAgencies = (jogId: JogId, agencies: Agency[]): Agency[] => {
  const jogAgencies: Agency[] = [];

  agencies.forEach(agency => {
    if (agency.jogIds?.includes(jogId)) {
      // Add to JOG's agencies
      jogAgencies.push(agency);
      
      // Add to agencyJogsMap
      let set = agencyJogsMap.get(agency.id);
      if(set) {
        set.add(jogId);
      } else {
        agencyJogsMap.set(agency.id, new Set([jogId]));
      }
    }
  });

  return jogAgencies;
}

// todo: jcavner: Now only used in 1 util, which is used in reducer (which should move to saga). Have to figure out what to do instead.
export const GetJog = (jogId: JogId | string): Jog | undefined => {
  // Checking for single digit "number" format to transform to "actual ID" value of 0 padded strings
  const id = jogId;
  return JogMap.get(id);
}

export const MakeJogs = (agencies: Agency[]): Jog[] => {
  // create jogs
  const jogs = [
    makeJog(agencies, JogId.Other, "Other/Unassigned", "Other", notIsFilter, notIsUserJog),
    
    // Actual "Participating" JOGs
    makeJog(agencies, JogId.ClarkCounty, "Clark County JOG", "Clark Co."),
    makeJog(agencies, JogId.JBLM, "Joint Base Lewis-McChord JOG", "JBLM"),
    makeJog(agencies, JogId.KingCountyNortheast, "Northeast King County JOG", "NEJOG"),
    makeJog(agencies, JogId.KingCountySouth, "South King County JOG", "South JOG"),
    makeJog(agencies, JogId.KitsapPeninsula, "Kitsap Peninsula JOG", "Kitsap Pen."),
    makeJog(agencies, JogId.LowerColumbiaRiver, "Lower Columbia River JOG", "Lower Col. River"),
    makeJog(agencies, JogId.NorthwestWashington, "Northwest WA JOG", "NW WA"),
    makeJog(agencies, JogId.SeattleArea, "Seattle Area JOG", "SAJOG"),
    makeJog(agencies, JogId.SnohomishCounty, "Snohomish County JOG", "Snohomish Co."),
    makeJog(agencies, JogId.Tacoma, "Tacoma JOG", "Tacoma"),

    // "Group" (not an actual JOG)
    makeJog(agencies, JogId.EasternWashington, "Eastern WA Group", "Eastern WA", isFilter, isUserJog, isGroupOnly), // Temp group for areas covered by WSP districts 3, 4, 6. Not a JOG.
    makeJog(agencies, JogId.Wsp, "Washington State Patrol Districts", "WSP Districts", isFilter, notIsUserJog, isGroupOnly),
  ];  

  // Populate JOG map
  JogMap.clear()
  jogs.forEach((jog) => {
    JogMap.set(jog.id, jog);
  });

  return jogs;
}